export default __webpack_public_path__ + "static/media/cp_geo_pg.abc81ff9.svg";